/**
 * Created by tong on 2018/2/28
 */
import {config, request} from 'Utils';

/**
 * 加入收藏夹列表
 * @param param
 * @returns {*}
 */
export function getShoppingCarList(param) {
    return request(`${config.server}/api/v1/dms/collect/getListByNum`, {
        method: 'post',
        body: param
    });
}
/*移出收藏夹*/
export function deleteShoppingCarList(param) {
    return request(`${config.server}/api/v1/dms/collect/delete`, {
        method: 'post',
        body: param
    });
}
/*加入购物车*/
export function addFavoritesList(param) {
    return request(`${config.server}/api/v1/dms/shoppingCart/insertPc`, {
        method: 'post',
        body: param
    });
}



// WEBPACK FOOTER //
// ./src/service/favorites/index.js